(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-modal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('editorial-modal')) {
    class EditorialModal extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;

        this.key = this.dataset.storageKey;
        this.delay = Number(this.dataset.delay || 3) * 1000;
        this.cooldown = Number(this.dataset.cooldown || 14) * 864e5;

        this.querySelectorAll('[data-close-modal]').forEach((el) =>
          el.addEventListener('click', () => this.close())
        );
        this.dialog.addEventListener('cancel', (e) => {
          e.preventDefault();
          this.close();
        });
        this.querySelector('[data-copy-code]')?.addEventListener('click', (e) => this.copy(e.currentTarget));

        // Theme editor: never auto-open on page load; open when the section is selected
        if (this.dataset.designMode !== undefined) {
          const id = this.dataset.sectionId;
          document.addEventListener('shopify:section:select', (e) => {
            if (e.detail.sectionId === id && this.dataset.designMode !== 'none') this.open();
          });
          document.addEventListener('shopify:section:deselect', (e) => {
            if (e.detail.sectionId === id) this.close(false);
          });
          return;
        }

        const postedHere = location.hash === '#' + this.dataset.formId;
        const state = this.dataset.state;

        if (postedHere && state === 'success') {
          this.save({ subscribed: true });
          this.cleanUrl();
          this.open();
          return;
        }
        if (postedHere && state === 'error') {
          this.open();
          this.querySelector('input[type="email"]')?.focus();
          return;
        }
        // Another form on the page was posted → leave this one alone this load
        if (state !== 'form') return;
        if (this.isSuppressed()) return;

        this.timer = setTimeout(() => this.open(), this.delay);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
      }

      open() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        requestAnimationFrame(() => this.dialog.classList.add('is-visible'));
      }

      close(remember = true) {
        if (!this.dialog.open) return;
        this.dialog.classList.remove('is-visible');
        const done = () => this.dialog.close();
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        reduced ? done() : setTimeout(done, 300);

        if (remember && this.dataset.designMode === undefined) {
          const current = this.read();
          if (!current || !current.subscribed) this.save({ until: Date.now() + this.cooldown });
        }
      }

      isSuppressed() {
        const record = this.read();
        if (!record) return false;
        return record.subscribed === true || Date.now() < record.until;
      }

      read() {
        try {
          return JSON.parse(localStorage.getItem(this.key));
        } catch (e) {
          return null;
        }
      }

      save(value) {
        try {
          localStorage.setItem(this.key, JSON.stringify(value));
        } catch (e) {}
      }

      cleanUrl() {
        try {
          const url = new URL(location.href);
          url.searchParams.delete('customer_posted');
          url.hash = '';
          history.replaceState(history.state, '', url.pathname + url.search);
        } catch (e) {}
      }

      async copy(button) {
        const code = button.dataset.copyCode;
        const label = button.querySelector('[data-code-label]');
        const status = this.querySelector('[data-copy-status]');
        try {
          await navigator.clipboard.writeText(code);
        } catch (e) {
          return;
        }
        button.classList.add('is-copied');
        label.textContent = 'Copied';
        if (status) status.textContent = 'Code ' + code + ' copied';
        clearTimeout(this.copyTimer);
        this.copyTimer = setTimeout(() => {
          button.classList.remove('is-copied');
          label.textContent = code;
          if (status) status.textContent = '';
        }, 1600);
      }
    }

    customElements.define('editorial-modal', EditorialModal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-collection-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('video-collection-list')) return;

    class VideoCollectionList extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;

        this.cards = [...this.track.querySelectorAll('[data-card]')];
        this.dotsEl = this.querySelector('[data-dots]');
        this.prevBtns = [...this.querySelectorAll('[data-prev]')];
        this.nextBtns = [...this.querySelectorAll('[data-next]')];

        this.autoplayCarousel = this.dataset.autoplayCarousel === 'true';
        this.autoplaySpeed = (parseInt(this.dataset.autoplaySpeed, 10) || 5) * 1000;
        this.activeIdx = 0;
        this.dots = [];

        this.onScroll = this.onScroll.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.setupEventListeners();
        this.initDots();
        this.setupVideos();
        this.updateNavigation();
        this.initCarouselAutoplay();

        // Responsive recomputation
        this.ro = new ResizeObserver(() => {
          this.initDots();
          this.updateNavigation();
        });
        this.ro.observe(this);
      }

      disconnectedCallback() {
        this.ro?.disconnect();
        this.videoObserver?.disconnect();
        clearInterval(this.carouselTimer);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      setupEventListeners() {
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.prevBtns.forEach(btn => btn.addEventListener('click', () => this.scrollPrev()));
        this.nextBtns.forEach(btn => btn.addEventListener('click', () => this.scrollNext()));
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      /* ---------- VIDEO PLAYBACK MANAGER (BULLETPROOF IOS AUTOPLAY + FALLBACK) ---------- */
      setupVideos() {
        const videoCards = this.cards.filter(card => card.classList.contains('vcl__card--has-video'));
        if (!videoCards.length) return;

        videoCards.forEach(card => {
          const video = card.querySelector('[data-video-element]');
          const fallbackWrap = card.querySelector('[data-fallback-wrap]');
          if (!video) return;

          // Essential for iOS Safari WebKit policy: both muted & defaultMuted must be set
          video.muted = true;
          video.defaultMuted = true;
          video.volume = 0;
          video.playsInline = true;
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');

          const playVideo = () => {
            video.muted = true;
            video.defaultMuted = true;
            const p = video.play();
            if (p && typeof p.catch === 'function') {
              p.catch(() => {
                // If blocked by iOS Low Power Mode, poster image displays seamlessly
              });
            }
          };

          // Try playing immediately if already loaded
          if (video.readyState >= 2) {
            playVideo();
          } else {
            video.addEventListener('loadedmetadata', playVideo, { once: true });
            video.addEventListener('canplay', playVideo, { once: true });
          }

          // If video fails or encounters error, show static fallback image
          video.addEventListener('error', () => {
            video.style.display = 'none';
            if (fallbackWrap) fallbackWrap.style.display = 'block';
          });
        });

        // Global iOS kickstart: on first user touch/scroll gesture, wake up any pending videos
        const unlockIOSAutoplay = () => {
          videoCards.forEach(card => {
            const video = card.querySelector('[data-video-element]');
            if (video && video.paused) {
              video.muted = true;
              video.defaultMuted = true;
              const p = video.play();
              if (p && typeof p.catch === 'function') p.catch(() => {});
            }
          });
          window.removeEventListener('touchstart', unlockIOSAutoplay);
          window.removeEventListener('scroll', unlockIOSAutoplay);
        };
        window.addEventListener('touchstart', unlockIOSAutoplay, { passive: true, once: true });
        window.addEventListener('scroll', unlockIOSAutoplay, { passive: true, once: true });

        // IntersectionObserver: pause when completely offscreen, resume when in viewport
        this.videoObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            const video = entry.target.querySelector('[data-video-element]');
            if (!video) return;

            if (entry.isIntersecting) {
              video.muted = true;
              video.defaultMuted = true;
              const p = video.play();
              if (p && typeof p.catch === 'function') p.catch(() => {});
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.15 });

        videoCards.forEach(card => {
          this.videoObserver.observe(card);
        });
      }

      /* ---------- CAROUSEL LOGIC & NAVIGATION ---------- */
      isCarouselActive() {
        const isDesktop = window.innerWidth >= 750;
        const desktopCarousel = this.dataset.desktopCarousel === 'true';
        const mobileCarousel = this.dataset.mobileCarousel === 'true';
        return (isDesktop && desktopCarousel) || (!isDesktop && mobileCarousel);
      }

      initDots() {
        if (!this.dotsEl) return;
        this.dotsEl.innerHTML = '';
        if (!this.isCarouselActive() || this.cards.length <= 1) {
          this.dotsEl.style.display = 'none';
          return;
        }

        this.dotsEl.style.display = 'flex';
        this.dots = this.cards.map((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = `vcl__dot${i === 0 ? ' is-active' : ''}`;
          dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
          dot.addEventListener('click', () => this.goTo(i));
          this.dotsEl.appendChild(dot);
          return dot;
        });
      }

      getCardOffset(card) {
        return card.offsetParent === this.track ? card.offsetLeft : card.offsetLeft - this.track.offsetLeft;
      }

      goTo(index) {
        const target = this.cards[Math.max(0, Math.min(index, this.cards.length - 1))];
        if (!target) return;
        this.track.scrollTo({
          left: this.getCardOffset(target),
          behavior: 'smooth'
        });
      }

      scrollPrev() {
        if (!this.cards.length) return;
        const cardWidth = this.cards[0].offsetWidth;
        const gap = parseInt(window.getComputedStyle(this.track).gap, 10) || 16;
        this.track.scrollBy({ left: -(cardWidth + gap), behavior: 'smooth' });
      }

      scrollNext() {
        if (!this.cards.length) return;
        const cardWidth = this.cards[0].offsetWidth;
        const gap = parseInt(window.getComputedStyle(this.track).gap, 10) || 16;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;

        if (this.autoplayCarousel && this.track.scrollLeft >= maxScroll - 6) {
          this.goTo(0);
        } else {
          this.track.scrollBy({ left: cardWidth + gap, behavior: 'smooth' });
        }
      }

      onScroll() {
        if (this.scrollTicking) return;
        this.scrollTicking = true;
        requestAnimationFrame(() => {
          this.scrollTicking = false;
          this.updateNavigation();
        });
      }

      updateNavigation() {
        if (!this.cards.length || !this.isCarouselActive()) return;

        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        let activeIndex = 0;

        if (this.track.scrollLeft >= maxScroll - 6) {
          activeIndex = this.cards.length - 1;
        } else {
          let minDiff = Infinity;
          const currentLeft = this.track.scrollLeft;
          this.cards.forEach((card, i) => {
            const cardLeft = this.getCardOffset(card);
            const diff = Math.abs(cardLeft - currentLeft);
            if (diff < minDiff) {
              minDiff = diff;
              activeIndex = i;
            }
          });
        }

        this.activeIdx = activeIndex;

        // Update dots state
        if (this.dots.length) {
          this.dots.forEach((dot, i) => {
            dot.classList.toggle('is-active', i === activeIndex);
          });
        }

        // Update arrow button disabled status
        const isAtStart = this.track.scrollLeft <= 2;
        const isAtEnd = this.track.scrollLeft >= maxScroll - 4;
        this.prevBtns.forEach(btn => (btn.disabled = isAtStart));
        this.nextBtns.forEach(btn => (btn.disabled = isAtEnd));
      }

      initCarouselAutoplay() {
        if (!this.autoplayCarousel) return;

        const startAutoplay = () => {
          clearInterval(this.carouselTimer);
          this.carouselTimer = setInterval(() => {
            if (!this.isCarouselActive()) return;
            this.scrollNext();
          }, this.autoplaySpeed);
        };

        const stopAutoplay = () => {
          clearInterval(this.carouselTimer);
        };

        startAutoplay();
        this.addEventListener('mouseenter', stopAutoplay);
        this.addEventListener('mouseleave', startAutoplay);
        this.addEventListener('touchstart', stopAutoplay, { passive: true });
        this.addEventListener('touchend', startAutoplay, { passive: true });
      }

      /* ---------- SHOPIFY THEME EDITOR INTEGRATION ---------- */
      onBlockSelect(event) {
        if (!event.target || !this.contains(event.target)) return;
        const block = event.target.closest('[data-card]');
        if (!block) return;
        const index = this.cards.indexOf(block);
        if (index !== -1) {
          this.goTo(index);
        }
      }
    }

    customElements.define('video-collection-list', VideoCollectionList);
  })();

  } catch(e) { console.error(e); }
})();
})();
